import React, { useState } from 'react';
import InputField from "components/fields/InputField";
import CurrencyInput from 'react-currency-input-field';
import dataService from "service/dataService";
import Switch from "components/switch";
interface StudentDetails {
  firstName: string;
  lastName: string;
  fullName: string;
  hourlyRate: string | undefined;
  email: string;
  grade: string;
  major: string;
  phoneNumber: string;
}

// A simple formatter function. A real-world app would need more robust logic.
const formatPhoneNumber = (value: string): string => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const AddStudent: React.FC = () => {
  const [formData, setFormData] = useState<StudentDetails>({
    firstName: '',
    lastName: '',
    hourlyRate: '',
    email: '',
    grade: '',
    major: '',
    fullName: '',
    phoneNumber: ''
  });
  const [showAlert, setShowAlert] = useState(false);
  const [phoneValue, setPhoneValue] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [discount, setDiscount] =useState<number>();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setPhoneValue(formattedPhoneNumber);
    formData.phoneNumber = phoneValue;
  };

    const toggleSwitch = () => {
      setIsChecked(!isChecked);
      console.log(isChecked);
      if(isChecked){
        setDiscount(0);
      }
    }; 
  
    const handleDiscount = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        setDiscount(Number(value));
      }; 

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Add form submission logic here
    const myData = {
      uid:'',
      firstName: `${formData.firstName}`,
      lastName: formData.lastName,
      grade: formData.grade,
      hourlyRate: formData.hourlyRate || '',
      major: formData.major,
      email: formData.email,
      fullName: `${formData.firstName} ${formData.lastName}`,
      phoneNumber: phoneValue,
      discount:discount
    };
    console.log("myData"+myData);
    dataService.addStudentData(myData).then((id) => {
      //alert(`Student added successfully with ID: ${id}`);
      setShowAlert(true);
      setTimeout(() => {
     // window.location.reload();
      }, 3000); // 3000 milliseconds = 3 seconds
      // Reset form after successful submission
      setFormData({
        firstName: '',
        lastName: '',
        hourlyRate: '',
        email: '',
        grade: '',
        major: '',
        fullName: '',
        phoneNumber:'',
      });
    });
  };
  return (
    <div className="max-w-6xl mx-auto mt-1 p-6 bg-white shadow-lg rounded-lg">
    {/* Success Alert */}
    { showAlert && (
    <div id="alert-border-1" className="flex items-center p-4 mb-4 text-green-800 border-t-4 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-800 dark:border-green-800" role="alert">
     <svg className="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
       <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
     </svg>
     <div className="ms-3 text-sm font-medium">
        Student added successfully
      </div>
     </div>
     )}
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Use grid for a two-column layout on medium screens and up */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <InputField
             label="First Name"
             value={formData.firstName}
             onchange={(e) => setFormData({ ...formData, firstName: e.target.value })}
             required={true} 
             id={''} extra={''} placeholder={'Student First Name'} variant={''}          />
          <InputField
            label="Last Name"
           value={formData.lastName}
            onchange={(e) => setFormData({ ...formData, lastName: e.target.value })}
            required={true} 
            id={''} extra={''} placeholder={'Student Last Name'} variant={''}          />
  
          <InputField
            label="Email Address"
            type="email"
            value={formData.email}
            onchange={(e) => setFormData({ ...formData, email: e.target.value })}
            id={''} extra={''} placeholder={'email@apex.com'} variant={''}  
            required={false}
          />
           <div>
            <label htmlFor="grade" className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
              Grade
            </label>
            <select
              id="grade"
              name="grade"
              value={formData.grade}
              onChange={handleChange}
              required={true}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="">Select Grade</option>
              <option value="5">Grade 5</option>
              <option value="6">Grade 6</option>
              <option value="7">Grade 7</option>
              <option value="8">Grade 8</option>
              <option value="9">Grade 9</option>
              <option value="10">Grade 10</option>
              <option value="11">Grade 11</option>
              <option value="12">Grade 12</option>
            </select>
          </div>

          <InputField
            label="Major"
            value={formData.major}
            onchange={(e) => setFormData({ ...formData, major: e.target.value })}
            id={''} extra={''} placeholder={'eg: Precalculus'} variant={''}   
             required={true} 
          />
      <div>
      <label
        htmlFor="hourlyRate"
        className={`text-sm text-navy-700 dark:text-white ml-3 font-bold`}
      >
        Hourly Rate
      </label>
    
      {/* Currency Input Field */}
        <CurrencyInput
          id="hourlyRate"
          name="hourlyRate"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="Eg: $45.00"
          defaultValue={formData.hourlyRate ? parseFloat(formData.hourlyRate) : undefined}
          decimalsLimit={2} // Limit to 2 decimal places
          prefix="$" // Add a currency prefix
          intlConfig={{ locale: 'en-US', currency: 'USD' }} // Specify locale and currency
          onValueChange={(value: string | undefined) => setFormData({ ...formData, hourlyRate: value || '' })}
          required
        />
        </div>
        <div>
       <label htmlFor="phoneNumberCustom" className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
        Phone Number
      </label>
      <div className="mt-1">
        <input
          id="phoneNumberCustom"
          type="tel"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="(555) 555-5555"
          value={phoneValue}
          onChange={handlePhoneChange}
        />
        </div>
        </div>

         <div className="mt-4 flex items-center gap-3">
          <Switch id="switch1" onChange={toggleSwitch}/>
          <label
            htmlFor="checkbox2"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            Discount
          </label>

        
          <select id="discount"
           className="ml-10 w-62 p-2 border bg-gray-50 rounded-md border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block "
           style={{display: !isChecked ? 'none':'block'}}
           required onChange={handleDiscount}>
            <option selected>Select a Discount</option>
            <option value="5">5%</option>
            <option value="10">10%</option>
            <option value="15">15%</option>
            <option value="20">20%</option>
            <option value="25">25%</option>
          </select>
        </div>
         


        {/* Submit Button */}
        <div className="flex justify-end mt-6 ml-5">
          <button
            type="submit"
            className="px-4 py-2 bg-indigo-600 text-white font-semibold rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Save Details
          </button>
        </div>
        </div>
      </form>
    </div>
    
  );
};

export default AddStudent;